module.exports = __webpack_public_path__ + "ico-crypto-cake.svg?af6957bb6863296ca3dc3dce9fce16d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-cake.svg
// module id = 1152
// module chunks = 2